import "./App.css";
import React from "react";
import PagesRouting from "./Routing/PagesRouting";
import Navbar from "./pages/NavBar/Navbar";

function App() {
  return (
    <>
      <Navbar />
      <PagesRouting />
    </>
  );
}

export default App;
